<template>
  <div>
    <el-dialog
      top="20vh"
      width="500px"
      center
      :title="`确认ID为 ${
        confirmBankCardOnlineObj.id ? confirmBankCardOnlineObj.id : ''
      } 银行卡上线`"
      :visible="confirmBankCardOnlineObj.visible"
      @close="HandleCancel()"
    >
      <el-form v-if="confirmBankCardOnlineObj.bankName">
        <el-row>
          确认
          <span
            style="font-size: 20px; font-weight: 600; color: rgb(255, 166, 0)"
            >{{
              `${confirmBankCardOnlineObj.bankName} ${
                confirmBankCardOnlineObj.bankCardNumber
                  ? confirmBankCardOnlineObj.bankCardNumber
                      .match(/.{1,4}/g)
                      .join(" ")
                  : ""
              }`
            }}</span
          >
          上线
        </el-row>
        <br />
        <el-row>
          <el-col>
            <el-form-item label="请选择是否通过【扫脸】完成的登录">
              <el-radio :disabled="lock" v-model="statusRom" label="0"
                >非扫脸模式</el-radio
              >
              <el-radio :disabled="lock" v-model="statusRom" label="1"
                >扫脸模式</el-radio
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div style="text-align: center; margin-top: 30px">
        <el-button round @click="HandleCancel()"> 取消 </el-button>
        <el-button round type="primary" @click="HandleSubmit()">
          提交
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import { updateLoginStatus } from "@/api/account";
export default {
  mixins: [mainCommon],
  props: ["confirmBankCardOnlineObj"],
  data() {
    return {
      statusRom: "0",
      lock: false,
    };
  },
  watch: {
    confirmBankCardOnlineObj(row) {
      if (row.visible && this.confirmBankCardOnlineObj) {
        this.statusRom = this.confirmBankCardOnlineObj.statusRom.toString();
        // 若是有 1 代表选择过扫脸模式
        this.lock = this.confirmBankCardOnlineObj.statusRom ? true : false;
      }
    },
  },
  methods: {
    HandleCancel() {
      this.$emit("update:confirm-bank-card-online-obj", {});
    },
    HandleSubmit() {
      updateLoginStatus(this.confirmBankCardOnlineObj.id, {
        statusRom: this.statusRom,
      }).then((res) => {
        this.$notify.success(res.message);
        this.$emit("update:confirm-bank-card-online-obj", {});
        this.$emit("HandleGetList");
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/components/dialog/ConfirmBankCardOnline.vue